var useButtonUtils = function () {
    var createButtonClass = function (variant, size) {
        return createButtonTypeClass(variant) + " " + createButtonSizeClass(size);
    };
    var createButtonTypeClass = function (variant) {
        var selectedVariant = 'primary';
        switch (variant) {
            case 'primary':
            case 'secondary':
            case 'subtle':
            case 'flat':
            case 'cta':
                selectedVariant = variant;
                break;
            default:
                selectedVariant = 'primary';
                break;
        }
        return "btn-" + selectedVariant;
    };
    var createButtonSizeClass = function (size) {
        var selectedSize = 'md';
        switch (size) {
            case 'large':
                selectedSize = 'lg';
                break;
            case 'medium':
            default:
                selectedSize = 'md';
                break;
            case 'small':
                selectedSize = 'sm';
                break;
            case 'extra-small':
                selectedSize = 'xs';
                break;
        }
        return "btn-" + selectedSize;
    };
    return { createButtonClass: createButtonClass };
};
export default useButtonUtils;
